import {Component, inject, input, model, OnInit} from '@angular/core';
import {TemplateDTO} from "../../common/model/template-dto.model";
import {EventDTO} from "../../model/event.model";
import {Place} from "../../model/place.model";
import {TemplateActionService} from "../../service/template-action.service";
import {EventActionService} from "../../service/event-action.service";
import {PlaceActionService} from "../../service/place-action.service";
import {TrackableEntity} from "../../model/trackable-entity.model";

@Component({
  selector: 'app-favorite-btn',
  templateUrl: './favorite-btn.component.html',
  styleUrls: ['./favorite-btn.component.scss'],
})
export class FavoriteBtnComponent  implements OnInit {

  iconType = input<'favorite' | 'bookmark'>('favorite');
  type = input<'template' | 'event' | 'place' | 'default'>();
  entity = model<TrackableEntity>();

  private templateActionService = inject(TemplateActionService);
  private eventActionService = inject(EventActionService);
  private placeActionSvc = inject(PlaceActionService);

  constructor() { }

  ngOnInit() {}

  onToggle() {


    switch (this.type()) {
      case 'template':
        this.templateActionService.toggleFavorite(this.entity() as TemplateDTO).subscribe();
        break;
      case 'event':
        this.eventActionService.toggleFavorite(this.entity() as EventDTO).subscribe();
        break;
      case 'place':
        this.placeActionSvc.toggleFavorite(this.entity() as Place<any>).subscribe();
        break;
      default:
        throw new Error('Unknown trackable entity');
        break;

    }

  }
}
